import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const STORAGE_KEY = "web-cart"

const state = {
    collectables: [

        // ---------------------------------------------------------------
        /* __________ |  _______  || | BLUE | || |_______| ||__________|*/
        // ---------------------------------------------------------------

        {
            id: 0,
            name: "Beer Bottles",
            description: "Blue Gate was nearest to the local pub, and quite often, women would stop over on their way back for a bit of a party.",
            image: "/images/collectables/Bottles.png",
            link: "/artifact/0",
            audiotitle: "Peacecamp Newbury Berkshire",
            audioartist: "Greenham Songbook, covered by Jenny and Flo Crowe",
            audio: "/audio/contributed/blue/PeacecampNEWburyBerkshire.mp3",
            model: "/models/collectables/Bottles.glb"
        },
        {
            id: 1,
            name: "Bolt Cutters",
            description: "A crucial part of many a Greenham Woman's toolkit. They became increasingly hard to find, as hardware shops were encouraged not to sell them to anyone suspected of being a Greenham Woman.",
            image: "/images/collectables/Bolt_Cutters.png",
            link: "/artifact/1",
            audiotitle: "Tomorrow",
            audioartist: "Written by Peggy Seeger, performed by Alice Robinson",
            audio: "/audio/contributed/blue/Tomorrow.mp3",
            model: "/models/collectables/Bolt_Cutters.glb"
        },
        {
            id: 2,
            name: "Car",
            description: "The baillifs would often take anything they could pick up and would impound vehicles as well.",
            image: "/images/collectables/Car.png",
            link: "/artifact/2",
            audiotitle: "Bailiffs",
            audioartist: "Written by Michelle Witthaus, performed by John Gorrick and Elka de Wit",
            audio: "/audio/contributed/blue/Bailiffs.mp3",
            model: "/models/collectables/Car.glb"
        },
        {
            id: 3,
            name: "Diary",
            description: "Many gates kept detailed diaries written collectively by the women that lived there, cataloguing the myriad of experiences at the camp and its communities.",
            image: "/images/collectables/Diary.png",
            link: "/artifact/3",
            audiotitle: "A Few Pages In The Life of Blue Gate",
            audioartist: "Written by Penny Rackett, performed by Ali Belbin, Faye Wilson, Jo Liptrott, Gilly Tomkins, Shazz Andrew, Lladel Bryant",
            audio: "/audio/contributed/blue/Diary.mp3",
            model: "/models/collectables/Diary.glb"
        },
        {
            id: 4,
            name: "Letters",
            description: "A lot of women left the camp when the cruise missiles left, but a hard core, commited group stayed on to help the local people get the common given back to the British people - a mission in which they were eventually successful.",
            image: "/images/collectables/Letters.png",
            link: "/artifact/4",
            audiotitle: "Staying on Letters",
            audioartist: "Letters kindly provided by xRay, read by Becky Barry, John Gorick, T.J. Holmes, Jo Liptrott, Bec Appleby and Faye Wilson",
            audio: "/audio/contributed/blue/StayingOn.mp3",
            model: "/models/collectables/Letters.glb"
        },
        {
            id: 5,
            name: "Newspapers",
            description: "The women were generally treated badly by the media, especially the Daily Mail and The Sun but were generally pretty well supported by The Guardian.",
            image: "/images/collectables/Newspapers.png",
            link: "/artifact/5",
            audiotitle: "Behind the Headlines",
            audioartist: "Written by Juliet Margetts, performed by Faye Wilson",
            audio: "/audio/contributed/blue/BehindTheHeadlines.mp3",
            model: "/models/collectables/Newspapers.glb"
        },
        {
            id: 6,
            name: "Phone box",
            description: "The local telephone boxes were vital when it came to organising campaigns such as cruise watch, when locals would be asked to spread the word of the missiles coming out of blue gate through their carefully organised telephone trees that soon made the movement of these supposedly secret convoys nationally known.",
            image: "/images/collectables/Phonebox.png",
            link: "/artifact/6",
            audiotitle: "Answering Machine",
            audioartist: "Marie Knowles",
            audio: "/audio/contributed/blue/AnsweringMachine_MarieKnowles.mp3",
            model: "/models/collectables/Phonebox.glb"
        },
        {
            id: 7,
            name: "Record Player",
            description: "The record player was a treasured item that added to the gate's reputation for being fun and throwing good parties.",
            image: "/images/collectables/Record_Player.png",
            link: "/artifact/7",
            audiotitle: "Take the Toys from Boys",
            audioartist: "Originally by the Poison Girls, cover performed by Becky Barry and T.J. Holmes",
            audio: "/audio/contributed/blue/TakeTheToysFromTheBoys.mp3",
            model: "/models/collectables/Record_Player.glb"
        },
        {
            id: 8,
            name: "Sofa",
            description: "People donated all sorts of things to different gates, including sofas, tents, clothing and provisions.",
            image: "/images/collectables/Sofa.png",
            link: "/artifact/8",
            audiotitle: "Going Underground",
            audioartist: "Written and performed by Fi Read",
            audio: "/audio/contributed/blue/GoingUnderground.mp3",
            model: "/models/collectables/Sofa.glb"
        },
        {
            id: 9,
            name: "Tipi",
            description: "This is a song from the We Have a Dream album, that artists like Peggy Seeger, Frankie Armstrong, Naomi Littlebear Morena and Holly Near created with Greenham Women during their time at the camp. It was recorded in a studio lent to them by Pete Townsend in support of the cause.",
            image: "/images/collectables/Tipi.png",
            link: "/artifact/9",
            audiotitle: "No More Genocide",
            audioartist: "Written and performed by Holly Near",
            audio: "/audio/contributed/blue/NoMoreGenocide.mp3",
            model: "/models/collectables/Tipi.glb"
        },
        {
            id: 10,
            name: "Campfire",
            description: "Visitors to Greenham, part-time women and members of CND would often sit up around the campsite, chatting, talking politics and telling stories. They provided Night Watch so that the women living at camp could get a much-needed night's rest without worrying about vigilantes or other interferance.",
            image: "/images/collectables/Campfire_Blue.png",
            link: "/artifact/10",
            audiotitle: "You Know What Sucks",
            audioartist: "Written by L. H. Trevail, performed by Rebecca Mordan",
            audio: "/audio/contributed/blue/YouKnowWhatSucks.mp3",
            model: "/models/collectables/Campfire_Blue.glb"
        },
        {
            id: 11,
            name: "Autumn Moon",
            description: "Jansson is now best known for her creation of the Moomins, but she was also famous in her day as an illustrator, satirist, novelist and social commentator.",
            image: "/images/collectables/Autumn_Moon.png",
            link: "/artifact/11",
            audiotitle: "Extract from The Exploits of Moominpappa",
            audioartist: "Written by Tove Jansson, performed by Rebecca Mordan.",
            audio: "/audio/contributed/blue/ToveMoomin.mp3",
            model: "/models/collectables/Autumn_Moon.glb"
        },
        {
            id: 12,
            name: "Songsheets",
            description: "This song is one of our favourite examples of how the Greenham Women took existing songs and adapted them to celebrate life at the camp.",
            image: "/images/collectables/Songsheet_Peace.png",
            link: "/artifact/12",
            audiotitle: "Peace Camp",
            audioartist: "From the Greenham Songbook, performed by Emily Faulkner",
            audio: "/audio/contributed/blue/PeaceCamp.mp3",
            model: "/models/collectables/Songsheet_Peace.glb"
        },
        {
            id: 13,
            name: "Cans of Food",
            description: "Susan Kleckner was a feminist filmmaker, photographer, performance artist and writer who helped define the Feminist Art Movement. She participated in and photographed the Greenham Common Women’s Peace Camp during the mid-1980s and in 1987, curated a major year-long installation called WindowPeace.",
            image: "/images/collectables/Food_can.png",
            link: "/artifact/13",
            audiotitle: "Leaderless Action",
            audioartist: "Written and voiced by Christina Li",
            audio: "/audio/contributed/blue/LeaderlessAction_SusanKleckner.mp3",
            model: "/models/collectables/Food_Can.glb"
        },
        {
            id: 14,
            name: "Letters",
            description: "The Friend's Meeting House in Newbury supported the Greenham Women for most of the camp's history, despite this being a controversial decision to some locals and members of the congregation.",
            image: "/images/collectables/Letters_friends.png",
            link: "/artifact/14",
            audiotitle: "Friends Letters",
            audioartist: "Letters kindly provided by xRay, read by xRay and Ali Belbin",
            audio: "/audio/contributed/blue/FriendsLetters.mp3",
            model: "/models/collectables/Letters_Friends.glb"
        },

        // -----------------------------------------------------------------
        /* ___________ |  _______  || | GREEN | || |_______| ||___________|*/
        // -----------------------------------------------------------------

        {
            id: 15,
            name: "Campfire",
            description: "Green Gate was often the scene of conflict resolution and women often came here for help resolving differences.",
            image: "/images/collectables/Campfire.png",
            link: "/artifact/15",
            audiotitle: "Common Ground",
            audioartist: "Written by Michelle Witthaus, performed by Kudzanayi Chiwawa, Bec Appleby and Jo Liptrott",
            audio: "/audio/contributed/green/CommonGround.mp3",
            model: "/models/collectables/Campfire.glb"
        },
        {
            id: 16,
            name: "Drum",
            description: "Like Zohl, the Australian writer of the poem you just heard, women came to Greenham from around the world. Polynesians, Native Americans and women from other campaigns were invited to speak and stay at the camp in a cultural exchange of experiences.",
            image: "/images/collectables/Drum.png",
            link: "/artifact/16",
            audiotitle: "And Women Dance",
            audioartist: "Written by Zohl de Ishtar, performed by Bec Appleby",
            audio: "/audio/contributed/green/AndWomenDance.mp3",
            model: "/models/collectables/Drum.glb"
        },
        {
            id: 17,
            name: "Fiddle",
            description: "Women created music at the camp to entertain each other, pass the time and boost morale.",
            image: "/images/collectables/Fiddle.png",
            link: "/artifact/17",
            audiotitle: "Bird Song Blackbird",
            audioartist: "Written and performed by Carolyn Francis",
            audio: "/audio/contributed/green/BirdsongBlackbird.mp3",
            model: "/models/collectables/Fiddle.glb"
        },
        {
            id: 18,
            name: "Homeopathy",
            description: "Green Gate was where women would go for healing and lots of alternative therapies were practised there, such as homeopathy and reiki.",
            image: "/images/collectables/Homeopathy.png",
            link: "/artifact/18",
            audiotitle: "Healing",
            audioartist: "Written by Rebecca Mordan, performed by Rebecca Mordan and Shazz Andrew",
            audio: "/audio/contributed/green/Healing.mp3",
            model: "/models/collectables/Homeopathy.glb"
        },
        {
            id: 19,
            name: "Meal Prep",
            description: "Meals were often the scene of collaborative time amongst the women.",
            image: "/images/collectables/Meal_prep.png",
            link: "/artifact/19",
            audiotitle: "Speech to Apollo / Out of the Darkness",
            audioartist: "Written and performed by Frankie Armstrong",
            audio: "/audio/contributed/green/SpeechToApollo.mp3",
            model: "/models/collectables/Meal_Prep.glb"
        },
        {
            id: 20,
            name: "Tin Whistle",
            description: "Lots of musicians visited the camp, as well as staying there, including The Fallout Marching Band, who went round the gates boosting morale at big actions and demonstrations.",
            image: "/images/collectables/Tin_Whistle.png",
            link: "/artifact/20",
            audiotitle: "Best Tin Whistle with Dog",
            audioartist: "Written and performed by Carolyn Francis",
            audio: "/audio/contributed/green/BestTinWhistle.mp3",
            model: "/models/collectables/Tin_Whistle.glb"
        },
        {
            id: 21,
            name: "Paints",
            description: "Paints were used for banner-making and decorations, but also for Non-Violent Direct Actions such as painting feminist or peace symbols on American aircraft.",
            image: "/images/collectables/Paints.png",
            link: "/artifact/21",
            audiotitle: "In a Glass Darkly",
            audioartist: "Written and sung by Rebecca Mordan, cello by T.J. Holmes",
            audio: "/audio/contributed/green/ThroughAGlassDarkly.mp3",
            model: "/models/collectables/Paints.glb"
        },
        {
            id: 22,
            name: "Wash Tree",
            description: "Women at Green Gate talk about decorating trees with mirrors and toiletries to communaly perform their ablutions in the morning.",
            image: "/images/collectables/Wash_Tree.png",
            link: "/artifact/22",
            audiotitle: "Women Make Your Choice",
            audioartist: "From the We Have a Dream album, written by Rachel Hay Hoe. Performed by Emily Falkner",
            audio: "/audio/contributed/yellow/WomenMakeYourChoice.mp3",
            model: "/models/collectables/Wash_Tree.glb"
        },
        {
            id: 23,
            name: "Wool",
            description: "The women used arts and crafts to decorate the camp, including weaving wool into the military fences and tying memorabilia such as letters, photos and toys to the wire.",
            image: "/images/collectables/Wool.png",
            link: "/artifact/23",
            audiotitle: "Weaving the Wool",
            audioartist: "Written by Juliet Margetts, performed by Tracy Kearney and Terina Talbot",
            audio: "/audio/contributed/green/WeavingTheWool.mp3",
            model: "/models/collectables/Wool.glb"
        },
        {
            id: 24,
            name: "Songsheets",
            description: "This Holly Near song was orginally written in response to Harvey Milk's assassination for the grieving crowd to sing. It was originally entitled, We Are a Gentle Angry People and Holly rewrote it for the Women's movement.",
            image: "/images/collectables/Songseet_Angry.png",
            link: "/artifact/24",
            audiotitle: "Gentle Angry Women",
            audioartist: "Written by Holly Near, performed by Carleen Anderson",
            audio: "/audio/contributed/green/GentleAngryWomen.mp3",
            model: "/models/collectables/Songsheet_Angry.glb"
        },
        {
            id: 25,
            name: "Songsheets",
            description: "This song was recorded during the pandemic lockdown of 2020. To get the atmosphere right, Carolyn recorded herself singing by a campfire and then visited a selection of her friends with whom she camped at Green Gate to layer up the rest of the recordings.",
            image: "/images/collectables/Songsheet_Witches.png",
            link: "/artifact/25",
            audiotitle: "We Are The Witches",
            audioartist: "From the Greenham Songbook, performed by Carolyn Francis and friends",
            audio: "/audio/contributed/green/WeAreWitches.mp3",
            model: "/models/collectables/Songsheet_Witches.glb"
        },
        {
            id: 26,
            name: "Trees",
            description: "This selection of material is a tribute to author and co-founder of the Fabian Society, E.Nesbit. She is best known now for her contribution to children's literature, but in her day, she was equally applauded as a journalist, horror writer and poet.",
            image: "/images/collectables/Tree.png",
            link: "/artifact/26",
            audiotitle: "Shadow / A Dirge",
            audioartist: "Written by E.Nesbit, performed by Rebecca Mordan, Rosie Hughes and Dickon Knowles",
            audio: "/audio/contributed/green/Salon.mp3",
            model: "/models/collectables/Tree.glb"
        },
        {
            id: 27,
            name: "Tent",
            description: "Susan Kleckner was a feminist filmmaker, photographer, performance artist and writer who helped define the Feminist Art Movement. She participated in and photographed the Greenham Common Women’s Peace Camp during the mid-1980s and in 1987, curated a major year-long installation called WindowPeace.",
            image: "/images/collectables/Tent.png",
            link: "/artifact/27",
            audiotitle: "A Woman Lived Here",
            audioartist: "Written and voiced by Christina Li",
            audio: "/audio/contributed/green/AWomanLivedHere_SusanKleckner.mp3",
            model: "/models/collectables/Tent.glb"
        },
        {
            id: 28,
            name: "Wash Tub",
            description: "The women were very ingenious about how they washed, which included showering with snow in the winter and laboriously boiling water for hours for a bath over a campfire.",
            image: "/images/collectables/Wash_Tub.png",
            link: "/artifact/28",
            audiotitle: "Lockdown Waltz",
            audioartist: "Written and performed by Carolyn Francis",
            audio: "/audio/contributed/green/LockDownWaltz.mp3",
            model: "/models/collectables/Wash_Tub.glb"
        },
        {
            id: 29,
            name: "Message Wheel",
            description: "Message wheels were created by attaching bits of material and messages to sections cut from the perimeter fence. These were often used to connect with campaigns in other parts of the world. One message wheel was created at Greenham and sent to the women at Pine Gap Peace Camp in Australia and the women there sent one to Greenham, which remains with a Greenham Woman in Newbury today.",
            image: "/images/collectables/Dreamcatcher.png",
            link: "/artifact/29",
            audiotitle: "Magic of Greenham",
            audioartist: "Written by Maggie Parks, read by Mary Woodvine",
            audio: "/audio/contributed/green/TheMagicOfGreenham.mp3",
            model: "/models/collectables/Dreamcatcher.glb"
        },
        {
            id: 30,
            name: "Summer Sun",
            description: "Spirituality and goddess worship were a big part of Green Gate. Dragons were a big theme at Greenham and a repeated iconic image, partly in homage to the Welsh women who walked to Greenham and set up camp in September 1981.",
            image: "/images/collectables/Sun_Green.png",
            link: "/artifact/30",
            audiotitle: "Freya Web",
            audioartist: "Written by Mercedes Kemp, performed by Kudzanayi Chiwawa and cast",
            audio: "/audio/contributed/green/FreyaWeb.mp3",
            model: "/models/collectables/Sun_Green.glb"
        },

        // -----------------------------------------------------------------
        /* __________ |  _______  || | YELLOW | || |_______| ||__________|*/
        // -----------------------------------------------------------------

        {
            id: 31,
            name: "Main Gates",
            description: "Once the Greenham Women arrived, more and more fence was put up until 9 miles of it reached all the way around the RAF Greenham base. The women set up camps at most of the gates around the base and the biggest was here at Yellow gate, the main entrance to the base.",
            image: "/images/collectables/Main_gates.png",
            link: "/artifact/31",
            audiotitle: "4 Minutes / Intro to Yellow Gate",
            audioartist: "Written by Sue Say, read by Rone Stevens; 4 Minutes to Midnight from the Greenham Song Book",
            audio: "/audio/contributed/yellow/4MIntroToYellowGate.mp3",
            model: "/models/collectables/Main_Gates.glb"
        },
        {
            id: 32,
            name: "Benders",
            description: "In order to be able to grab their homes and move quickly away from the bailliffs, a style of tent referred to as a 'bender' was developed, apparently by some of the Quakers. It was generally plastic and/or blankets pulled over branches, in the traditional style of early nomadic people.",
            image: "/images/collectables/Benders.png",
            link: "/artifact/32",
            audiotitle: "Bolt Cutters",
            audioartist: "Written by Juliet Margetts, read by Illona Linthwaite and Becca Holburt",
            audio: "/audio/contributed/yellow/Boltcutters.mp3",
            model: "/models/collectables/Benders.glb"
        },
        {
            id: 33,
            name: "Water Spout",
            description: "This was the only source of water at the camp. If women needed water, they had to go to Yellow Gate. When women from Yellow Gate visited other gates, they would usually bring water with them.",
            image: "/images/collectables/Water_Spout.png",
            link: "/artifact/33",
            audiotitle: "River of Birds",
            audioartist: "From the Greenham Songbook, sung by Kathy Trevelyan",
            audio: "/audio/contributed/yellow/RiverOfBirdsRound.mp3",
            model: "/models/collectables/Water_Spout.glb"
        },
        {
            id: 34,
            name: "Provisions",
            description: "People from all over the country donated provisions to the camp from food, drink and tents to sanitary pads.",
            image: "/images/collectables/Provisions.png",
            link: "/artifact/34",
            audiotitle: "Hamper",
            audioartist: "Written by Rebecca Mordan, performed by Lladel Bryant, Tanya Myers and Gilly Tompkin",
            audio: "/audio/contributed/yellow/HamperScene.mp3",
            model: "/models/collectables/Provisions.glb"
        },
        {
            id: 35,
            name: "Typewriter",
            description: "The typewriter was a prized item. A key, shared resource on which the women created newsletters, pamphlets and invitations to actions.",
            image: "/images/collectables/Typewriter.png",
            link: "/artifact/35",
            audiotitle: "Silos Song",
            audioartist: "Written and sung by Rebecca Johnson",
            audio: "/audio/contributed/yellow/TheSilosSong.mp3",
            model: "/models/collectables/Typewriter.glb"
        },
        {
            id: 36,
            name: "Papers",
            description: "Lots of art and academia was created through women's experiences at Greenham Common.",
            image: "/images/collectables/Papers.png",
            link: "/artifact/36",
            audiotitle: "Womon Poem",
            audioartist: "Written by Sue Say, read by Roisin Bermingham",
            audio: "/audio/contributed/yellow/WomonPoem_Roisin.mp3",
            model: "/models/collectables/Papers.glb"
        },
        {
            id: 37,
            name: "Glasses",
            description: "The women were at Greenham in all weathers, through the wind, rain and sunshine. A recurring theme in our interviews with them is how much mud there could be ...",
            image: "/images/collectables/Glasses.png",
            link: "/artifact/37",
            audiotitle: "By Way of Apology",
            audioartist: "Written by Lyn Barlow, performed by Becca Hulbert",
            audio: "/audio/contributed/yellow/ByWayOfApology_BeccaHulbert.mp3",
            model: "/models/collectables/Glasses.glb"
        },
        {
            id: 38,
            name: "Books",
            description: "There are some amazing books that Greenham Women have written about the peace camp, including Walking to Greenham by Ann Pettitt and Other Girls Like Me by Stephanie Davies. An anecdotal history is soon to be published by the History Press, based on the interviews of the women you are listening to today, written by Rebecca Mordan and Kate Kerrow.",
            image: "/images/collectables/Books.png",
            link: "/artifact/38",
            audiotitle: "Yellow Wallpaper",
            audioartist: "Written by Charlotte Gilmore-Perkins, performed by Rebecca Mordan",
            audio: "/audio/contributed/yellow/TheYellowWallpaper.mp3",
            model: "/models/collectables/Books.glb"
        },
        {
            id: 39,
            name: "Cups and Plates",
            description: "The camp had a vegetarian policy, and many of the women were vegan.",
            image: "/images/collectables/Cups_Plates.png",
            link: "/artifact/39",
            audiotitle: "Let There Be Womanly Times",
            audioartist: "Written by Frankie Armstrong, performed by Chloë Clarke",
            audio: "/audio/contributed/green/InTheBeginning.mp3",
            model: "/models/collectables/Cups_Plates.glb"
        },
        {
            id: 40,
            name: "Guitar",
            description: "Music was a huge part of life at camp. Women used it to pass the time, to collaborate creatively and to find solidarity during actions.",
            image: "/images/collectables/Guitar.png",
            link: "/artifact/40",
            audiotitle: "Carry Greenham Home",
            audioartist: "Written and performed by Peggy Seeger",
            audio: "/audio/contributed/yellow/CarryGreenhamHome.mp3",
            model: "/models/collectables/Guitar.glb"
        },
        {
            id: 41,
            name: "Sleeping Bag",
            description: "One of the most cherished donations that the Greenham Women ever got was anything made of Gortex, which had only recently been invented. This could be in the form of clothes or sleeping bags.",
            image: "/images/collectables/Sleeping_Bag.png",
            link: "/artifact/41",
            audiotitle: "Lesbians",
            audioartist: "Written by Sue Say, read by Emily Faulkner; Leah's Song from the Greenham Song Book",
            audio: "/audio/contributed/yellow/Lesbians.mp3",
            model: "/models/collectables/Sleeping_Bag.glb"
        },
        {
            id: 42,
            name: "Shit Pit",
            description: "The women dug shit pits and used a similar method to compost loos today to dispose of their waste - Women often went in pairs or groups to avoid harassment from vigilantes; the question Greenham Women remember visitors asked most about where the women went to the loo; the first job often given to a newbie to camp was to help dig a shit pit!",
            image: "/images/collectables/Shit_Pit.png",
            link: "/artifact/42",
            audiotitle: "The Ballad of Freda Geese",
            audioartist: "Becky Griffiths",
            audio: "/audio/contributed/yellow/TheBallardOfFredaGeese_BeckyGriffiths.mp3",
            model: "/models/collectables/Shit_Pit.glb"
        },
        {
            id: 43,
            name: "Teapot",
            description: "Much of the quiet time at camp was spent chatting round the fire over cups of tea.",
            image: "/images/collectables/Teapot.png",
            link: "/artifact/43",
            audiotitle: "Snow Patrol",
            audioartist: "Written by Rebecca Mordan, performed by Jenny and Flo Crowe, Shazz Andrew and Roisin Bermingham",
            audio: "/audio/contributed/yellow/SnowPatrol.mp3",
            model: "/models/collectables/Teapot.glb"
        },
        {
            id: 44,
            name: "Benders",
            description: "At first, the women had tents and tipis to live in and store their provisions, but these were soon destroyed by the bailiffs and the women's living conditions became more basic.",
            image: "/images/collectables/Bender.png",
            link: "/artifact/44",
            audiotitle: "Nightwatch",
            audioartist: "Written by Sue Say, read by Gilly Tompkin, The Way that We Do It from the Greenham Song Book",
            audio: "/audio/contributed/yellow/Nightwatch.mp3",
            model: "/models/collectables/Bender.glb"
        },
        {
            id: 45,
            name: "Songsheet",
            description: "Yellow gater, Liz Beech, feels this song was about her friend Sarah, and wrote this short eulogy to her for this exhibition: I first met Sarah (Hipperson) in 1983 at a High Court hearing.  When I first lived at the camp in the October of that year I lived in her bender for a while, Sarah being on one of her frequent (22) visits to prison. We were close friends and I did a number of actions with her. Sarah was a remarkable woman - a Glaswegian taking no nonsense from anyone. I well remember, during the period when the camp (Yellow Gate) was being evicted on a daily basis and we were sleeping in the open in Gortex sleeping bags, Sarah emerging from hers in underwear and socks as the police tramped though, challenging them about entering her bedroom! Sarah is visible at the very end of the film Carry Greenham Home berating the press for clustering around 'the action' and having nothing to say for themselves. Sarah died aged 90 in October 2018. I still miss her.",
            image: "/images/collectables/Songsheet_Sarah.png",
            link: "/artifact/45",
            audiotitle: "Sarah's Song",
            audioartist: "From the Greenham Song book, cover by Jenny and Flo Crowe",
            audio: "/audio/contributed/yellow/SarahsSong.mp3",
            model: "/models/collectables/Songsheet_Sarah.glb"
        },
        {
            id: 46,
            name: "Songsheet",
            description: "The Greenham Women compiled their own Greenham Song Book with original songs as well as popular songs they had put their own lyrics to.",
            image: "/images/collectables/Songsheet_Here.png",
            link: "/artifact/46",
            audiotitle: "Here at Greenham",
            audioartist: "Written by Gillian Booth / Greenham Songbook, cover by Jenny and Flo Crowe",
            audio: "/audio/contributed/yellow/HereAtGreenhamOnASpree.mp3",
            model: "/models/collectables/Songsheet_Here.glb"
        },
        {
            id: 47,
            name: "Tipi",
            description: "Christina Li wrote and voiced these fictional memories based on the visits of photographer Susan Kleckner to Greenham and the photographs she took there.",
            image: "/images/collectables/Tipiyellow.png",
            link: "/artifact/47",
            audiotitle: "10 MM Women",
            audioartist: "Written and performed by Christina Li, photograph by Susan Kleckner",
            audio: "/audio/contributed/yellow/10MMWomen_SusanKleckner.mp3",
            model: "/models/collectables/Tipiyellow.glb"
        },
        {
            id: 48,
            name: "Bushes",
            description: "These memories of Yellow Gate were written by Sue Say and recorded in various voices to suggest the range of women who came to the camp.",
            image: "/images/collectables/Bushes.png",
            link: "/artifact/48",
            audiotitle: "Action at the Opposition",
            audioartist: "Written by Sue Say, read by Deborah Tracey, song written by Margot Random from the 'We Have a Dream' album",
            audio: "/audio/contributed/yellow/ActionATheOpposition.mp3",
            model: "/models/collectables/Bushes.glb"
        },
        {
            id: 49,
            name: "Winter Sun",
            description: "The song you can hear playing was by Naomi Little Bear and can be found in it’s original form on the awesome We Have a Dream LP",
            image: "/images/collectables/Sun_Yellow.png",
            link: "/artifact/49",
            audiotitle: "Like A Mountain",
            audioartist: "Written by Naomi Littlebear Morena, performed by Christina Li",
            audio: "/audio/contributed/yellow/LikeAMountain.mp3",
            model: "/models/collectables/Sun_Yellow.glb"
        },
    ],
    WebCart: [],
    discovered: [],
    audioInfoPopped: false
}
const getters = {
    collectables: (state) => state.collectables,
    WebCart: (state) => state.WebCart,
    discovered: (state) => state.discovered,
    audioInfoPopped: (state) => state.audioInfoPopped,
}
const mutations = {
    ADD_Item(state, id) {
        state.WebCart.push(id)
    },
    REMOVE_Item(state, index) {
        state.WebCart.splice(index, 1);
    },
    DISCOVER_Item(state, id) {
        state.discovered.push(id)
    },
    AUDIO_Popped(state, value) {
        state.audioInfoPopped = value
    }


}
const actions = {
    addItem(context, id){
        context.commit("ADD_Item", id)
        syncItems()

    },
    removeItem(context, index) {
        context.commit("REMOVE_Item", index)
        syncItems()
    },

    discoverItem(context, id){
        context.commit("DISCOVER_Item", id)
    },

    audioInfoPopped(context, value){
        context.commit("AUDIO_Popped", value)
    },
}

let tempArray = []

function syncItems() {
    tempArray = []
    //console.log('Store: about to sync')
    let currentCartItems = state.WebCart.map(cartItems => {
        return state.collectables.find(items => {
            return cartItems === items.id;
        });
    })
    currentCartItems.forEach(pushIds)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tempArray))

}

function pushIds(item){
    //console.log('Store: single item id ' + item.id)
    tempArray.push(item.id)
}

function getCartContents(){
    return state.WebCart.map(cartitems => {
        return state.collectables.find(itemAvailable => {
            return cartitems === itemAvailable.id;
        });
    });
}
/*
function findItemLink(linkPassed){
    return state.collectables.find(objectLink => {
        return objectLink.link === linkPassed
    });
}*/



function findItemById(idPassed){
    return state.collectables.find(objectLink => {
        return objectLink.id === idPassed
    });
}


function findDiscoveredById(idPassed){
    //console.log(state.discovered)
    return state.discovered.find(objectLink => {
        //console.log(objectLink)
        return objectLink === idPassed
    });
}


const modules = {}

export {state, getters, mutations, actions, modules, STORAGE_KEY, getCartContents, findItemById, findDiscoveredById}
